/**
 * Which of the supported languages a short text is written in – or null when that cannot be
 * told (too short, another language, only numbers and units). Used to answer in the language
 * the user wrote in and to record the language of a reply. A rule-based guess from function
 * words: deterministic, offline, and honest about not knowing.
 *
 * A language pack adds its function words here.
 */
const FUNCTION_WORDS = {
    de: new Set('der die das den dem des ein eine einen einem einer und oder aber nicht kein keine ich du wir ihr sie es ist sind war mit ohne für von zu zum zur im in auf aus bei nach wie was wann wo warum kann kannst können soll muss möchte bitte danke noch auch schon nur sehr mehr statt anstatt stattdessen wenn dann dass weil mir mich dir dich'.split(' ')),
    en: new Set('the a an and or but not no i you we they it is are was were with without for of to in on at from by how what when where why can could should must would please thanks also only very more instead if then that because me my your this these those do does have has'.split(' ')),
};
const CHARACTERISTIC = { de: /[äöüß]/i };
export function detectLanguage(text, candidates) {
    const words = text
        .toLowerCase()
        .split(/[^\p{L}']+/u)
        .filter(Boolean);
    if (words.length === 0)
        return null;
    const languages = candidates ?? Object.keys(FUNCTION_WORDS);
    const scores = languages.map((language) => {
        let score = 0;
        for (const word of words)
            if (FUNCTION_WORDS[language].has(word))
                score += 1;
        if (CHARACTERISTIC[language]?.test(text))
            score += 1;
        return { language, score };
    });
    scores.sort((a, b) => b.score - a.score);
    const [best, second] = scores;
    if (!best || best.score === 0)
        return null;
    // One function word decides a short message ("und Eier?"); a long one needs a clear lead.
    const needed = words.length <= 4 ? 1 : 2;
    if (best.score < needed)
        return null;
    if (second && best.score - second.score < (words.length <= 4 ? 1 : 2))
        return null;
    // Function words of a supported language inside a text that is mostly something else.
    if (words.length >= 8 && best.score / words.length < 0.15)
        return null;
    return best.language;
}
//# sourceMappingURL=detect-language.js.map